import {Injectable} from '@angular/core';
import {AuthService} from "./auth.service";
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(
    private router: Router,
    private authService: AuthService
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let authenticated = this.authService.isAuthenticated()

    console.log("Authenticated", authenticated)
    if (authenticated) {
      return true
    } else {
      this.router.navigate(['/auth/login'], {
        queryParams: {
          returnUrl: state.url
        }
      })
      return false
    }
  }
}
